import { ApiClient } from "../config/axiosConfig";
import {
  ICreateSupplieslogistics,
  IQuerySuppliesLogistics,
  ISuppliesLogistics,
  IUpdateSuppliesLogistics,
} from "../models/Logistics";
import { IPaginatedResponse } from "../models/Pagination";

export const logisticsService = {
  getSupplierLogistics: (query: IQuerySuppliesLogistics) => {
    const response = ApiClient.GET<IPaginatedResponse<ISuppliesLogistics>>(
      `/logistics/supplies`,
      query,
    );
    return response;
  },
  createSupplierLogistics: (data: ICreateSupplieslogistics) => {
    const response = ApiClient.POST<ISuppliesLogistics>(
      `/logistics/supplies`,
      data,
    );
    return response;
  },
  updateSupplierLogistics: (id: number, data: IUpdateSuppliesLogistics) => {
    const response = ApiClient.PATCH<ISuppliesLogistics>(
      `/logistics/supplies/${id}`,
      data,
    );
    return response;
  },
  deleteSupplierLogistics: (id: number) => {
    const response = ApiClient.DELETE(`/logistics/supplies/${id}`);
    return response;
  },
  searchSupplierLogistics: (query: string) => {
    const response = ApiClient.GET<ISuppliesLogistics>(
      `/logistics/supplies/${query}`,
    );
    return response;
  },
};
